// AUTO-GENERATED by scripts/build-registry.js: study entry for aeronautics/crosswind-limit.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/aeronautics/crosswind-limit/crosswind-limit.js';

mount([g0]);
